// Core functionality that should be available on all pages
import './core/utils'; // New utility file for common functions
import './core/polyfills'; // Polyfills for older browsers

// Use the existing script in a non-webpack way
import './components/navigation';
import './components/mobile-navigation';
import './components/scroll';
import './components/anchors';
import './components/modal';
import './components/infusion-alphabet';
import './components/slider';
import './components/accordion';
import './components/tabs';
import './components/horizontal-tabs';
import './components/gallery';
import './components/gallery-lightbox';
import './pages/icons';
import './components/infusion-accordion';
import './components/infusion-accordion-alphabet';
import './components/team';
// logos
import './components/logos';

// Add core utilities
import './core/utils';

// Comment out webpack-specific dynamic imports since we'll use the loader script instead
/*
const componentsToLoad = {
    // ...components definitions...
};

const pageScripts = {
    // ...page definitions...
};

// Dynamic component loading function
function loadComponents() {
    // ...loading logic...
}

// Initialize after DOM is loaded
document.addEventListener('DOMContentLoaded', loadComponents);
*/
